import { clsx } from 'clsx'
import { type ButtonHTMLAttributes, type ChangeEventHandler, type DetailedHTMLProps, forwardRef } from 'react'
import { MagnifyingGlass } from '../icons/MagnifyingGlass.js'
import classes from './search-field.module.css'

type SearchFieldProps = {
  value?: string
  onFocus?: () => void
  onChange?: ChangeEventHandler<HTMLInputElement>
  autoFocus?: boolean
  className?: string
  collapseBorder?: boolean
  disableFocusVisual?: boolean
  endAdornmentLabel?: string
  slotProps?: {
    input?: DetailedHTMLProps<ButtonHTMLAttributes<HTMLInputElement>, HTMLInputElement>
    root?: DetailedHTMLProps<ButtonHTMLAttributes<HTMLDivElement>, HTMLDivElement>
  }
}

export const SearchField = forwardRef<HTMLDivElement, SearchFieldProps>(function TextField(props, ref) {
  const {
    value,
    onFocus,
    onChange,
    autoFocus,
    className,
    collapseBorder,
    endAdornmentLabel,
    disableFocusVisual,
    slotProps: { input: inputProps, root: rootProps } = {},
  } = props

  const rootClass = clsx(className, classes.root, rootProps?.className, {
    [classes.collapseBorder]: collapseBorder,
    [classes.disableFocusVisual]: disableFocusVisual,
  })
  const inputClass = clsx(classes.input, inputProps?.className)

  return (
    <div {...rootProps} className={rootClass} ref={ref}>
      <MagnifyingGlass className={classes.lens} />
      <input
        autoComplete="off"
        placeholder="Search Stories"
        type="text"
        {...inputProps}
        // biome-ignore lint/a11y/noAutofocus: <explanation>
        autoFocus={autoFocus}
        className={inputClass}
        onChange={onChange}
        onFocus={onFocus}
        value={value}
      />
      {endAdornmentLabel ? <h6 className={classes.adornment}>{endAdornmentLabel}</h6> : null}
    </div>
  )
})
